module.exports = __webpack_public_path__ + "static/media/a158.e02ea5c9.jpg";